// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import styles from './index.module.scss';
import { InfoBlock } from 'components/molecules/MyPage/InfoBlock';
import { Field } from 'components/molecules/MyPage/Field';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';
import { useMypageContactInfo } from 'util/hooks/useMypageContactInfo';
import { MyPageType } from 'types/mypage';
import { REGEX_OBJECT } from 'util/ConstantValues';
import Popover from 'components/atoms/Popover';
import { IconInfo } from 'components/atoms/icons/IconInfo';

export const AdminPool = () => {
  const { t } = useTranslation();
  const user = useSelector(selectUser);
  const hasValidUser = !!user.userId && !!user.role;

  const myPage = useMypageContactInfo<MyPageType.AdminPool>({
    myPageType: MyPageType.AdminPool,
    enabled: hasValidUser,
  });

  return (
    <div className={styles.mypage}>
      <div className={styles.generalInfo}>
        <InfoBlock
          className={styles.accountInfo}
          title={t('my_page.account_info.title')}
        >
          <div className={styles.col}>
            <Field
              label={t('my_page.account_info.account_category')}
              value={t('my_page.admin_pool.master_info.account_category')}
            />
            <Field
              label={t('my_page.account_info.account_permissions')}
              value={t('my_page.admin_pool.master_info.account_permissions')}
            />
          </div>
        </InfoBlock>
        <InfoBlock
          className={styles.masterInfo}
          title={t('my_page.admin_pool.master_info.title')}
        >
          <div className={styles.grid}>
            <Field
              label={t(
                'my_page.admin_pool.master_info.organization_name_label'
              )}
              value={t('my_page.admin_pool.master_info.organization_name')}
            />
            <Field
              label={t('my_page.admin_pool.master_info.manager_email')}
              extraLabel={
                <Popover
                  content={t('my_page.admin_pool.master_info.email_tooltip')}
                  positions={['top']}
                  containerStyle={{
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  <span style={{ display: 'inline-flex' }}>
                    <IconInfo fill="#878787" />
                  </span>
                </Popover>
              }
              value={myPage.data?.mail}
              format="email"
              maxLength={100}
              onEdit={async (value) => {
                if (value === myPage.data?.mail) {
                  return;
                }

                await myPage.handleChangeInfo({
                  mail: value,
                  tel: myPage.data?.tel ?? '',
                });
              }}
            />
            <Field
              label={t('my_page.admin_pool.master_info.phone_number')}
              value={myPage.data?.tel}
              format="phone"
              maxLength={15}
              regex={REGEX_OBJECT.number}
              onEdit={async (value) => {
                if (value === myPage.data?.tel) {
                  return;
                }

                await myPage.handleChangeInfo({
                  mail: myPage.data?.mail ?? '',
                  tel: value,
                });
              }}
            />
          </div>
        </InfoBlock>

        <InfoBlock title={t('my_page.admin_pool.management_station.title')}>
          <div className={styles.stations}>
            {myPage?.data?.stations.map((station, index) => (
              <div key={station.name + index} className={styles.station}>
                <div className={styles.name}>{station.name}</div>
                <div className={styles.numberOfSites}>
                  {station.siteCount}
                  <span className={styles.sitesLabel}>
                    {t(`common.${station.siteCount > 1 ? 'sites' : 'site'}`)}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </InfoBlock>
      </div>
    </div>
  );
};
